import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
  return null; // Retornar null cuando no hay errores
}

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const pwdRegexp = /(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])/;
  if (control.value && !pwdRegexp.test(control.value)) {
    return { invalidPassword: true };
  }
  return null;
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
  return (group: UntypedFormGroup): ValidationErrors | null => {
    const password = group.controls[passwordKey];
    const passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      passwordConfirmation.setErrors({ mismatchedPasswords: true });
      return { mismatchedPasswords: true };
    }
    passwordConfirmation.setErrors(null); // Eliminar cualquier error previo
    return null;
  };
}
